import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
// const loginUrl = `${apiUrl}/auth/login`;
// const refreshTokenUrl = `${apiUrl}/auth/refresh/token`;

axios.interceptors.request.use(
  (config) => {
    const accessToken = sessionStorage.getItem("token");

    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// axios.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   function (error) {
//     const originalRequest = error.config;
//     if (error.response && error.response.status === 401) {
//     }
//     if (error.response && originalRequest.url !== loginUrl) {
//       if (error.response.status === 401 && !originalRequest._retry) {
//         originalRequest._retry = true;

//         const accessToken = sessionStorage.getItem("access-token");
//         const refreshToken = sessionStorage.getItem("refresh-token");

//         const payload = {
//           accessToken,
//           refreshToken,
//         };

//         return axios.post(refreshTokenUrl, payload).then((res) => {
//           if (res.status === 200) {
//             const newAccessToken = res.data.accessToken;
//             const newRefreshToken = res.data.refreshToken;

//             sessionStorage.setItem("access-token", newAccessToken);
//             sessionStorage.setItem("refresh-token", newRefreshToken);

//             axios.defaults.headers.common["Authorization"] =
//               `Bearer ${newAccessToken}`;

//             return axios(originalRequest);
//           }
//         });
//       }
//     }

//     return Promise.reject(error);
//   }
// );

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
